export default __webpack_public_path__ + "static/media/ApplicationApprovedCheck.c0616095.svg";